import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-false",
  "use": "icon-false-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-false\">\n<g id=\"icon-false_&#229;&#133;&#179;&#233;&#151;&#173;\">\n<path id=\"icon-false_Vector 434\" d=\"M12.7441 3.9707L3.70524 13.0096\" stroke=\"#FD0563\" stroke-width=\"1.59787\" stroke-linecap=\"round\" />\n<path id=\"icon-false_Vector 435\" d=\"M12.7451 13.0089L3.70622 3.97001\" stroke=\"#FD0563\" stroke-width=\"1.59787\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol